import { render, staticRenderFns } from "./modal-task-link-dropdown.vue?vue&type=template&id=31c3da10&"
import script from "./modal-task-link-dropdown.vue?vue&type=script&lang=js&"
export * from "./modal-task-link-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./modal-task-link-dropdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports